import { render, staticRenderFns } from "./BalanceTable.vue?vue&type=template&id=1551fb2e&"
import script from "./BalanceTable.vue?vue&type=script&lang=js&"
export * from "./BalanceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports